<template>
    <custom-tooltip>
        <template v-if="staffIsLoaded" slot="contentTooltip">
            <compass-avatar
                :initials="initials"
                :is-blocked="isStaffBlocked(idStaff)"
                :is-deleted="isStaffDeleted(idStaff)"
                :src="staff ? staff.avatar : ''"
                :color-type="randAvatarColor"
                size="extra-small"
            />
            <span class="semibold">{{ content }}</span>
        </template>
        <CompassLink
            slot="triggerTooltip"
            :disabled="isStaffDeleted(idStaff)"
            :class="color"
            :link="idStaff ? '/staff/' + idStaff : '#'"
            class="mention"
            :target="idStaff ? '_blank' : '_self'"
            :label="text"
        >
        </CompassLink>
    </custom-tooltip>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CustomTooltip from 'vcomponents/utilities/CustomTooltip.vue';
import { capitalize } from 'lodash';

const { mapGetters } = createNamespacedHelpers('staffs');

const avatarColors = [
    'bg-component-background-avatar-random-green',
    'bg-component-background-avatar-random-yellow',
    'bg-component-background-avatar-random-pink',
];
export default {
    name: 'MentionTooltip',
    components: {
        CustomTooltip,
    },
    props: {
        idStaff: {
            type: Number,
            required: true,
        },
        userLoggedId: {
            type: Number,
            required: true,
        },
        fullName: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            staff: {},
            statusStaff: '',
            staffIsLoaded: false,
        };
    },
    computed: {
        ...mapGetters(['getStaffStatus', 'getOneStaff', 'isStaffDeleted', 'isStaffBlocked']),
        color() {
            if (this.userLoggedId !== this.idStaff) {
                return this.statusStaff === 'deleted'
                    ? 'gray-60 hover-gray-80'
                    : 'primary-50 hover-primary-100';
            }
            return 'warning-50 hover-warning-100';
        },
        content() {
            let content = this.fullname;
            if (!this.idStaff) {
                return content;
            }
            if (this.isStaffBlocked(this.idStaff)) {
                content = this.fullname + ' ' + this.$l10n.__('(désactivé)');
            } else if (this.isStaffDeleted(this.idStaff)) {
                content = this.fullname + ' ' + this.$l10n.__('(supprimé)');
            } else if (this.userLoggedId === this.idStaff) {
                content = this.fullname + ' ' + this.$l10n.__('(vous)');
            }
            return content;
        },
        fullname() {
            if (!this.staff || !this.idStaff || !this.isStaffDeleted(this.idStaff)) {
                return this.fullName;
            }
            return `${capitalize(this.staff.firstname)} ${capitalize(this.staff.lastname)}`;
        },
        randAvatarColor() {
            if (this.staff) {
                const chars = this.staff.firstname.length + this.staff.lastname.length;
                return avatarColors[chars % avatarColors.length];
            }
        },
        initials() {
            if (!this.staff || !this.idStaff || this.isStaffBlocked(this.idStaff) || this.isStaffDeleted(this.idStaff)) {
                return 'X';
            }
            if (this.staff) {
                return `${this.staff.firstname[0]}${this.staff.lastname[0]}`;
            }
            return 'X';
        },
    },
    created() {
        if (this.$store.state.staffs.staffs.length === 0) {
            this.$store.dispatch('staffs/fetchStaffs').then(() => {
                this.staff = this.getOneStaff(this.idStaff);
                this.statusStaff = this.getStaffStatus(this.idStaff);
                this.staffIsLoaded = true;
            });
        } else {
            this.staff = this.getOneStaff(this.idStaff);
            this.statusStaff = this.getStaffStatus(this.idStaff);
            this.staffIsLoaded = true;
        }
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.mention {
    text-decoration-line: none !important;
}

.tippy-box[data-theme~='tooltip-info-mention'] {
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 0 8px 0 #11111133;
    color: $gray-100;

    .tippy-content {
        padding: 0;
    }
}
</style>
